import _ from 'lodash';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace Objects {
  export const isEmpty = (obj: any) => _.isEmpty(obj);
  export const merge = (target: any, source: any) => _.merge(target, source);
  export const uniqBy = (data: any[], key: string) => _.uniqBy(data, key);
}
